// hashtags.js
'use strict';
import { fromJS } from 'immutable';
import {
  ADD_HASHTAGS,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
} from '../ActionTypes.js';

export const defaultState = fromJS({});

/**
 * Hashtags.
 * @module reducer/hashtags
 */
const hashtags = (state = defaultState, action) => {
  switch (action.type) {
    case ADD_HASHTAGS:
      return _ADD_HASHTAGS(action.payload)(state);
    // -- PLOP_PREPEND_REDUCER_SWITCH_CASE --
    default:
      return state;
  }
};

/**
 * Add hashtags
 * @kind reducer/actionType
 * @name _ADD_HASHTAGS
 * @param {object} {hashtags} - hashtags using hashtag as keys
 * @return {Immutable.Map} New state
 */
const _ADD_HASHTAGS =
  ({ hashtags }) =>
  state => {
    return state.mergeDeep(hashtags);
  };

// -- PLOP_PREPEND_REDUCER_ACTION_HANDLER --

export default hashtags;
